import axios from 'axios'
import router from './router'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 200000, // Request timeout in milliseconds
  headers: {
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use(config => {
  // If the URL starts with a slash and baseURL contains /api, strip the leading slash
  // to ensure axios appends it to the baseURL instead of the domain root.
  if (config.url && config.url.startsWith('/') && config.baseURL && config.baseURL.includes('/api')) {
    config.url = config.url.substring(1);
  }
  
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Add a response interceptor
apiClient.interceptors.response.use(
  response => {
    console.log('Response intercepted:', response);  // Log response for debugging
    return response;  // Return the response data as-is if successful
  },
  error => {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if 401 Unauthorized
      localStorage.removeItem('token'); // Optional: Clear token from local storage
      // router.push({ name: 'Login' });
      const store = require('@/store').default; // Import store
      store.commit('logout'); // Use logout instead of clearUser
      
      // Check if not already on login page before redirecting
      if (router.currentRoute.value.name !== 'Login') {
        router.push({ name: 'Login' });
      }
    }

    // Pass error along
    return Promise.reject(error)
  }
)

export default apiClient
